export default "__VITE_ASSET__XD9ZXo3D__"